export const SSR_LOADING = 'ssr';
export const LAZY_LOADING = 'lazy';
export const DISABLE_LOADING = 'disable';
